import module from 'nominas/nomina/module.js'
import template from './template.html'

export class NominasNominaDispersionStatusComponent {
  idEmpresa
  idNomina
  statusPagado
  cancelable
  onChange

  constructor (NominasNominaStatusPagado) {
    this.NominasNominaStatusPagado = NominasNominaStatusPagado
  }

  $onInit () {
    this.confirmar = false
    this.actualizando = false
    this.error = null
  }

  actualizar (status) {
    this.actualizando = true
    this.error = null

    return this.NominasNominaStatusPagado.put(this.idEmpresa, this.idNomina, {status_pagado: status})
      .then(({data}) => {
        this.confirmar = false
        this.statusPagado = data.status_pagado
        this.statusAprobado = data.status_aprobado
        this.onChange({$event: {data: data}})
      })
      .catch((error) => (this.error = error.data || error))
      .finally(() => (this.actualizando = false))
  }
}

module.component('nominasNominaDispersionStatus', {
  controller: NominasNominaDispersionStatusComponent,
  template,
  bindings: {
    idEmpresa: '<',
    idNomina: '<',
    statusPagado: '<',
    statusAprobado: '<',
    cancelable: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/dispersion/status/component.js